import "./index.scss";
import React from "react";

import { Avatar, OverseasMark, shortName } from "../atoms";

// The four groups a squad is read in. Batters and bowlers are padded to five
// rows so the cards in a grid stay the same height whether a team has filled
// its slots or not.
const GROUPS = [
  { key: "Batter", label: "Batters", min: 5 },
  { key: "Wicketkeeper", label: "Wicketkeepers", min: 2 },
  { key: "Bowler", label: "Bowlers", min: 5 },
  { key: "All Rounder", label: "All Rounders", min: 3 },
];

function Group({ label, entries, min, accent }) {
  const rows = [...entries];
  while (rows.length < min) rows.push(null);

  return (
    <div className="team-group">
      <div className="team-group-head">
        <span className="team-group-rule" style={{ background: accent }} />
        <span className="au-label team-group-label">{label}</span>
      </div>

      <ul className="team-group-list">
        {rows.map((entry, i) => {
          const player = entry?.Player;
          if (!player) {
            return (
              <li key={`empty-${i}`} className="team-slot empty">
                Open slot
              </li>
            );
          }
          return (
            <li key={player?._id || i} className="team-slot">
              <span className="team-slot-name">{shortName(player?.name)}</span>
              <OverseasMark nationality={player?.nationality} />
              {player?.uncapped && <span className="team-slot-tag">U</span>}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

const TeamCards = ({
  filteredPlayerData,
  teamName,
  teamColor,
  team,
  secondaryTeamColor,
  // The squad page names the team in its own heading, so the card there would
  // otherwise say it twice.
  headless,
}) => {
  const accent = teamColor || "#0040a8";
  const secondary = secondaryTeamColor || accent;
  const squadSize = GROUPS.reduce(
    (n, g) => n + (filteredPlayerData?.[g.key]?.length || 0),
    0
  );

  return (
    <article className="team-card">
      {!headless && (
      <header className="team-card-head">
        <Avatar name={teamName} src={team?.image} size={38} logo />
        <div className="team-card-title">
          <h2 className="team-card-name">{teamName}</h2>
          <p className="team-card-meta">
            {squadSize} {squadSize === 1 ? "player" : "players"}
          </p>
        </div>
        <span className="team-card-swatch" style={{ background: accent }} />
      </header>
      )}

      <div className="team-card-body">
        {GROUPS.map((g, i) => (
          <Group
            key={g.key}
            label={g.label}
            min={g.min}
            entries={filteredPlayerData?.[g.key] || []}
            accent={i % 2 === 0 ? accent : secondary}
          />
        ))}
      </div>
    </article>
  );
};

export default TeamCards;
